import React from 'react';
import { useTooltip } from './hooks';
import './style.scss';

type TooltipProps = {
  children: React.ReactNode;
  tooltipText?: string;
  tooltipPosition?: 'top' | 'bottom';
  disabled?: boolean;
};

const Tooltip = (props: TooltipProps) => {
  const { ref, position, handleMouseEnter, handleMouseLeave } = useTooltip();
  const className = `tooltip-wrapper ${props.tooltipPosition ?? 'top'}`;

  return (
    <span
      ref={ref}
      className="tooltip-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {props.children}
      {!props.disabled && (
        <span className={className} style={position ?? {}}>
          <span className="tooltip">
            <span className="tooltip-text">{props.tooltipText}</span>
          </span>
        </span>
      )}
    </span>
  );
};

export default Tooltip;
